import { useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import CreateClientForm from "./CreateClientForm";
import CreateButtonTrigger from "../../../../../../shared/components/button/CreateButtonTrigger";

const CreateClientDialog = ({ onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="clients.createForm.title"
      description="clients.createForm.description"
      content={<CreateClientForm onSubmitHandler={onSubmit} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateClientDialog;
